export const FIRM_NAME = "Trial Defence Law";
export const PHONE = "+65 8014 8989";
export const ADDRESS = "Carpenter Street, Singapore";
export const HOURS = "Mon–Fri: 11am–8pm | Weekends: By Appointment";
export const WHATSAPP_LINK = `https://wa.me/6580148989?text=Hello%2C%20I%20need%20legal%20advice%20regarding%20a%20claim%20trial`;

export const STATS = [
  { value: "15+", label: "Years Experience" },
  { value: "500+", label: "Cases Handled" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "Free", label: "Initial Consultation" },
];

export const PRACTICE_AREAS = [
  {
    id: "civil-claim-trial",
    icon: "⚖️",
    title: "Civil Litigation",
    desc: "We act for clients in contested civil disputes across Singapore's Magistrate's Courts, District Courts, and the High Court. We pursue and defend civil claims assertively.",
    category: "civil",
  },
  {
    id: "criminal-claim-trial",
    icon: "🔒",
    title: "Criminal Defence",
    desc: "Experienced criminal defence representation in Singapore's State Courts and High Court. We protect your rights, challenge evidence where appropriate, and provide robust courtroom representation.",
    category: "criminal",
  },
  {
    id: "contract-disputes",
    icon: "📋",
    title: "Contract Disputes",
    desc: "Enforce or defend breaches of contract — from commercial agreements and service contracts to employment agreements and joint ventures.",
    category: "civil",
  },
  {
    id: "debt-recovery",
    icon: "💰",
    title: "Debt Recovery",
    desc: "Swift and strategic debt recovery through an Originating Claim, summary judgment application, or statutory demand. We recover what is rightfully yours.",
    category: "civil",
  },
  {
    id: "criminal-defence",
    icon: "🛡️",
    title: "Criminal Defence",
    desc: "Defence for drug offences, white-collar crime, traffic offences, CBT, outrage of modesty, theft, assault, PDPA, and MCA matters.",
    category: "criminal",
  },
  {
    id: "property-disputes",
    icon: "🏠",
    title: "Property & Tenancy Disputes",
    desc: "Landlord-tenant conflicts, property damage claims, co-ownership disputes, and enforcement of property rights under Singapore law.",
    category: "civil",
  },
];

export const CIVIL_PROCESS_STEPS = [
  {
    step: "01",
    title: "Free Consultation",
    desc: "We assess your civil dispute, advise on the strength of your claim, and identify the appropriate court — Magistrate's Court, District Court, or High Court.",
  },
  {
    step: "02",
    title: "Letter of Demand",
    desc: "A formal letter is sent to the opposing party giving them an opportunity to comply before legal proceedings commence.",
  },
  {
    step: "03",
    title: "Filing an Originating Claim",
    desc: "Under the Rules of Court 2021, civil proceedings commence with an Originating Claim (OC) or Originating Application (OA). We prepare, file, and serve the correct document in the appropriate court.",
  },
  {
    step: "04",
    title: "Pleadings & Discovery",
    desc: "The claimant files a Statement of Claim; the defendant responds with a Defence (and any Counterclaim). All relevant documents are disclosed during discovery to lay out the full evidence.",
  },
  {
    step: "05",
    title: "Pre-Trial Conferences",
    desc: "The court manages the timeline, ensures all interlocutory applications are resolved, and may direct parties to attempt mediation.",
  },
  {
    step: "06",
    title: "Trial & Judgment",
    desc: "We present your case, examine witnesses, and make closing submissions. The judge delivers a binding judgment with cost orders.",
  },
];

export const CRIMINAL_PROCESS_STEPS = [
  {
    step: "01",
    title: "Arrest & Police Investigation",
    desc: "Upon arrest, the police may detain you for up to 48 hours before producing you in court. You have the right to remain silent and to engage a lawyer immediately. Do not make any statement without legal advice.",
  },
  {
    step: "02",
    title: "Criminal Mentions Court",
    desc: "You attend the Criminal Mentions Court where charges are formally read. You decide whether to plead guilty or claim trial. We advise you fully before any decision. We also apply for bail at this stage.",
  },
  {
    step: "03",
    title: "Claim Trial & Case Disclosure",
    desc: "If you claim trial, a Criminal Case Disclosure Conference (CCDC) is held. The prosecution discloses its evidence — charges, witness list, and exhibits. We review everything and build your defence strategy.",
  },
  {
    step: "04",
    title: "Criminal Case Management",
    desc: "For High Court matters (e.g. murder, drug trafficking), a committal hearing determines whether sufficient evidence exists to proceed. For State Court matters, the case is set down for trial after pre-trial steps are completed.",
  },
  {
    step: "05",
    title: "Criminal Trial",
    desc: "The prosecution presents its case first. We cross-examine every prosecution witness to expose weaknesses. After the prosecution closes its case, the court decides if there is a case to answer before we present your defence.",
  },
  {
    step: "06",
    title: "Verdict, Sentencing & Appeal",
    desc: "If acquitted, you are discharged. If convicted, we make strong mitigation submissions to minimise your sentence. Appeal rights apply — generally 14 days from sentencing, to the High Court or Court of Appeal.",
  },
];

export const FAQS = [
  // Civil FAQs
  {
    q: "What is a civil claim trial in Singapore?",
    a: "A civil claim trial is a court hearing where a judge listens to evidence from both parties and makes a legally binding decision on a private dispute between individuals or businesses. It is the final stage of civil litigation when parties cannot reach a settlement.",
    category: "civil",
  },
  {
    q: "Which court should I file my civil claim in?",
    a: "In Singapore: claims up to S$20,000 go to the Small Claims Tribunal; up to S$60,000 to the Magistrate's Court; S$60,000–S$250,000 to the District Court; and claims exceeding S$250,000 are filed in the High Court.",
    category: "civil",
  },
  {
    q: "How long do I have to file a civil claim in Singapore?",
    a: "Most contract and tort claims have a 6-year limitation period. Personal injury claims must be filed within 3 years. Small Claims Tribunal matters have a 2-year limit.",
    category: "civil",
  },
  {
    q: "What happens if the defendant does not respond to my civil claim?",
    a: "Under the Rules of Court 2021, if the defendant fails to file an Acknowledgement of Service or a Defence within the required timeframe, you may apply for judgment in default — a binding court order obtained without a full trial.",
    category: "civil",
  },
  {
    q: "Can I recover legal costs if I win my civil case?",
    a: "Yes. Singapore courts typically order the losing party to pay a portion of the winning party's legal costs. The exact amount is at the judge's discretion and may not cover all costs incurred.",
    category: "civil",
  },
  // Criminal FAQs
  {
    q: "What is a criminal claim trial in Singapore?",
    a: "A criminal claim trial is a court proceeding where the Public Prosecutor (on behalf of the State) brings charges against an accused person. The accused is presumed innocent until proven guilty beyond a reasonable doubt.",
    category: "criminal",
  },
  {
    q: "What should I do if I am arrested in Singapore?",
    a: "Remain calm, exercise your right to remain silent, and request to speak to a lawyer immediately. Do not make any statements to the police without legal advice. Contact us as soon as possible.",
    category: "criminal",
  },
  {
    q: "What is the difference between a civil and criminal claim trial?",
    a: "Civil litigation involves disputes between private parties seeking compensation or remedies. Criminal proceedings involve the State prosecuting a person for an offence. The standard of proof in criminal cases is 'beyond reasonable doubt' — much higher than the civil 'balance of probabilities'.",
    category: "criminal",
  },
  {
    q: "Can I get bail after being charged with a criminal offence?",
    a: "Bail is available for many offences in Singapore. Certain serious offences (e.g. murder, drug trafficking above specific thresholds) are non-bailable. We apply for bail and advise on bail conditions at the earliest opportunity.",
    category: "criminal",
  },
  {
    q: "What happens if I plead guilty in a criminal case?",
    a: "Pleading guilty may result in a reduced sentence as a mitigating factor. However, this decision must be made carefully with full legal advice. We analyse the prosecution's evidence, advise on prospects of acquittal, and if a plea is appropriate, present strong mitigation to minimise your sentence.",
    category: "criminal",
  },
];

export const TESTIMONIALS = [
  {
    name: "David Tan",
    role: "Business Owner",
    text: "My contract dispute at the District Court was handled with exceptional skill. Honest about our chances from day one, and secured a judgment in our favour. Highly recommended.",
    stars: 5,
  },
  {
    name: "Sarah Lim",
    role: "Property Investor",
    text: "I had a difficult tenancy dispute with a non-paying tenant. The team filed swiftly and obtained a default judgment within weeks. Professional and efficient throughout.",
    stars: 5,
  },
  {
    name: "Michael Ng",
    role: "Accused Client",
    text: "Facing criminal charges was the most stressful experience of my life. The team guided me through every step, challenged the prosecution's evidence, and I was acquitted. Eternally grateful.",
    stars: 5,
  },
];

export const ARTICLES = [
  {
    id: "civil-litigation-process-singapore",
    title: "A Complete Guide to the Civil Litigation Process in Singapore",
    category: "Civil Law",
    date: "15 May 2026",
    readTime: "8 min read",
    excerpt:
      "Civil litigation in Singapore follows a structured process governed by the Rules of Court 2021. This guide explains each stage — from letter of demand to final judgment — so you know exactly what to expect.",
    content: [
      {
        heading: "What is Civil Litigation?",
        body: "Civil litigation refers to the legal process by which private parties — individuals or businesses — resolve disputes through the courts. Unlike criminal law, which involves the State prosecuting an individual, civil litigation is a matter between private parties seeking remedies such as monetary damages, injunctions, or specific performance of a contract.",
      },
      {
        heading: "Which Court Handles Your Claim?",
        body: "The appropriate court depends on the value of your claim:\n• Small Claims Tribunal: up to S$20,000\n• Magistrate's Court: up to S$60,000\n• District Court: S$60,000 to S$250,000\n• High Court: above S$250,000\n\nThe parties may agree to cap a claim at S$250,000 to have it heard in the District Court.",
      },
      {
        heading: "Step 1: Letter of Demand",
        body: "Before commencing legal proceedings, the claimant (or their lawyer) typically sends a Letter of Demand to the opposing party. This formal notice outlines the claim and requests a remedy within a specified timeframe. While not mandatory under Singapore law, a Letter of Demand is strongly recommended as it may resolve the dispute without expensive litigation and demonstrates good faith to the court.",
      },
      {
        heading: "Step 2: Filing the Originating Claim",
        body: "Under the Rules of Court 2021 (in force from 1 April 2022), civil proceedings commence by filing an Originating Claim (OC) — which replaces the former Writ of Summons — or an Originating Application (OA) where material facts are not in dispute. The OC is filed by the claimant and must be served on the defendant, generally within 3 months of filing.",
      },
      {
        heading: "Step 3: Pleadings",
        body: "After the claim is filed and served, parties exchange written statements:\n• Statement of Claim: sets out the claimant's case and relief sought\n• Defence (and Counterclaim): responds to the allegations and raises any counterclaims\n• Reply: the plaintiff responds to the defence\n\nPleadings define the scope of the dispute and prevent either party from being ambushed at trial.",
      },
      {
        heading: "Step 4: Discovery",
        body: "Both parties are required to disclose all documents relevant to the dispute. Discovery ensures that evidence is not hidden and allows each party to assess the full strength of the case before trial. Applications can be made to compel production of specific documents.",
      },
      {
        heading: "Step 5: Pre-Trial Conference",
        body: "A judge manages the case timeline at pre-trial conferences, resolves procedural disputes, and may direct parties to attempt Court Dispute Resolution (mediation, neutral evaluation, or arbitration) before proceeding to trial.",
      },
      {
        heading: "Step 6: Trial",
        body: "At trial, each party presents evidence, examines and cross-examines witnesses, and makes legal submissions. The claimant bears the burden of proving their case on a balance of probabilities. After closing submissions, the judge delivers a judgment, which may include cost orders.",
      },
      {
        heading: "Step 7: Enforcement",
        body: "A judgment is only valuable if it can be enforced. Enforcement mechanisms in Singapore include: writs of seizure and sale, garnishee orders, examination of judgment debtors, and bankruptcy or winding-up applications.",
      },
    ],
  },
  {
    id: "criminal-trial-process-singapore",
    title: "Understanding the Criminal Trial Process in Singapore",
    category: "Criminal Law",
    date: "10 May 2026",
    readTime: "9 min read",
    excerpt:
      "Being charged with a criminal offence in Singapore is a serious matter. This guide explains every stage of the criminal trial process — from arrest and charge to verdict and appeal — so you understand your rights and what lies ahead.",
    content: [
      {
        heading: "The Criminal Justice System in Singapore",
        body: "Singapore's criminal justice system is adversarial — the Public Prosecutor (on behalf of the State) brings charges against an accused person, who is presumed innocent until proven guilty beyond a reasonable doubt. Criminal proceedings are governed by the Criminal Procedure Code 2010 (CPC) and the Evidence Act.",
      },
      {
        heading: "Step 1: Arrest and Investigation",
        body: "A person may be arrested with or without a warrant. Upon arrest, you have the right to remain silent and the right to engage a lawyer of your choice. Critically, you should not make any statement to the police without legal advice. The police may detain you for up to 48 hours before producing you in court.",
      },
      {
        heading: "Step 2: Criminal Mentions Court",
        body: "Once investigations are complete, you will attend the Criminal Mentions Court where charges are formally read. You must then decide whether to plead guilty or claim trial. If you plead guilty, you may be convicted and sentenced immediately or referred for a Plead Guilty (PG) mention. If you claim trial, your case proceeds to Criminal Case Disclosure Conference (CCDC). Your lawyer will also apply for bail at this hearing.",
      },
      {
        heading: "Step 3: Criminal Case Disclosure Conference (CCDC)",
        body: "For non-capital cases proceeding to trial, a Criminal Case Disclosure Conference (CCDC) is held. The prosecution discloses its case, including the charges, list of witnesses, and documentary exhibits. The defence is entitled to review this material to prepare its case.",
      },
      {
        heading: "Step 4: Committal Proceedings (High Court Cases)",
        body: "For serious offences tried in the High Court (e.g. murder, drug trafficking), committal proceedings are held to determine whether there is sufficient evidence for the case to proceed to trial. If the Magistrate finds a prima facie case, the accused is committed to stand trial in the High Court.",
      },
      {
        heading: "Step 5: The Criminal Trial",
        body: "At trial, the prosecution presents its case first — calling witnesses and tendering documentary evidence. The defence cross-examines each prosecution witness to expose weaknesses and inconsistencies. After the prosecution closes its case, the court assesses whether there is a case to answer. If so, the accused may give evidence or remain silent. The defence then presents its case.",
      },
      {
        heading: "Step 6: Verdict and Sentencing",
        body: "After considering all evidence and submissions, the judge delivers a verdict. If acquitted, the accused is discharged. If convicted, a separate sentencing hearing is held. The court considers aggravating and mitigating factors — a skilled lawyer will present compelling mitigation to minimise the sentence imposed.",
      },
      {
        heading: "Step 7: Appeal",
        body: "Both the prosecution and the accused have the right to appeal. An accused may appeal against conviction, sentence, or both. Appeals from the State Courts go to the High Court; appeals from the High Court go to the Court of Appeal. Strict timeframes apply — generally 14 days from sentencing.",
      },
      {
        heading: "Your Rights as an Accused Person",
        body: "You have the right to remain silent, the right to legal representation, the right to be informed of the charges against you, the right to apply for bail, and the right to a fair trial. These rights are fundamental — engage a lawyer as early as possible.",
      },
    ],
  },
  {
    id: "letter-of-demand-singapore",
    title: "What is a Letter of Demand and When Should You Send One?",
    category: "Civil Law",
    date: "5 May 2026",
    readTime: "5 min read",
    excerpt:
      "A Letter of Demand is often the first step before filing a civil claim in Singapore. Learn when to use one, what it should contain, and how it can resolve disputes without going to court.",
    content: [
      {
        heading: "What is a Letter of Demand?",
        body: "A Letter of Demand is a formal written notice sent by a claimant (or their lawyer) to a debtor or wrongdoer, requesting that they fulfil a legal obligation — such as paying a debt, returning property, or ceasing a wrongful act — within a specified timeframe, failing which legal proceedings will be commenced.",
      },
      {
        heading: "Is a Letter of Demand Required Before Suing?",
        body: "Under Singapore law, there is no general legal requirement to send a Letter of Demand before commencing legal proceedings. However, it is strongly recommended for several reasons:\n• It gives the other party an opportunity to resolve the matter amicably\n• It demonstrates good faith and may be taken into account by the court on costs\n• It puts the other party on notice and establishes a paper trail\n• It may resolve the dispute without the time and expense of litigation",
      },
      {
        heading: "What Should a Letter of Demand Include?",
        body: "A properly drafted Letter of Demand should include:\n• A clear statement of the facts giving rise to the claim\n• The specific legal basis for the claim (e.g. breach of contract, unjust enrichment)\n• The remedy sought (e.g. payment of S$50,000)\n• A reasonable deadline for compliance (typically 7–14 days)\n• A clear statement that legal proceedings will follow if the demand is not met\n• The sender's contact details or those of their lawyer",
      },
      {
        heading: "What Happens After a Letter of Demand?",
        body: "Three outcomes are possible:\n1. The other party complies — the matter is resolved\n2. The other party responds with a counter-proposal — negotiations may follow\n3. The other party ignores the demand — legal proceedings are commenced\n\nIn all cases, your lawyer will advise on the appropriate next steps.",
      },
      {
        heading: "Should I Engage a Lawyer to Send a Letter of Demand?",
        body: "While you may send a Letter of Demand yourself, a lawyer-drafted letter carries greater weight and legal precision. It signals that you are serious about your claim and may prompt a faster response. Our firm regularly drafts Letters of Demand for civil disputes of all sizes across Singapore.",
      },
    ],
  },
  {
    id: "bail-singapore-criminal",
    title: "Bail in Singapore: What You Need to Know",
    category: "Criminal Law",
    date: "28 April 2026",
    readTime: "6 min read",
    excerpt:
      "If you or a loved one has been arrested in Singapore, understanding the bail process is critical. This guide explains who can apply for bail, how it works, and what conditions may be imposed.",
    content: [
      {
        heading: "What is Bail?",
        body: "Bail is a conditional release from custody pending the resolution of a criminal matter. When bail is granted, the accused is released in exchange for a promise (secured by a sum of money or surety) to appear in court as required.",
      },
      {
        heading: "Bailable vs Non-Bailable Offences",
        body: "In Singapore, offences are classified as bailable or non-bailable under the Criminal Procedure Code:\n• Bailable offences: the accused has a right to bail (e.g. theft, cheating, minor traffic offences)\n• Non-bailable offences: bail is at the court's discretion (e.g. robbery, serious drug offences, murder)",
      },
      {
        heading: "How is Bail Applied For?",
        body: "At the first court mention, your lawyer may apply for bail on your behalf. The judge considers factors such as: the seriousness of the offence, the likelihood of the accused fleeing, criminal antecedents, and the strength of community ties. A surety (someone who pledges a sum of money and undertakes to ensure your attendance in court) may be required.",
      },
      {
        heading: "Common Bail Conditions",
        body: "Common bail conditions include:\n• Surrendering your passport\n• Reporting to a police station at specified intervals\n• Not contacting prosecution witnesses\n• Residing at a fixed address\n• Abstaining from alcohol or drugs\n\nBreaching bail conditions may result in bail being revoked and immediate remand.",
      },
      {
        heading: "What If Bail is Refused?",
        body: "If bail is refused, your lawyer may make a bail review application to the High Court. We act swiftly to make bail applications and, where necessary, challenge refusals before a High Court judge.",
      },
    ],
  },
];
